import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "質問編集")
], -1)
const _hoisted_3 = { class: "d-flex justify-content-center my-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2"
}, "更新", -1)

import { ref } from 'vue'
import { ConciergeCategory, ConciergeQuestion, ConciergeSection, useNicotto } from '@/plugins/nicotto'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import QuestionForm from '@/components/forms/ConciergeQuestion.vue'
import ConciergeHeaderQuestion from "@/components/parts/ConciergeHeaderQuestion.vue";
import ButtonDelete from "@/components/ui/ButtonDelete.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditView',
  props: {
    categoryId: null,
    sectionId: null,
    questionId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string
  sectionId: string
  questionId: string
}


const category = ref<ConciergeCategory>()
const section = ref<ConciergeSection>()
const question = ref<ConciergeQuestion>(new ConciergeQuestion())

const router = useRouter()
const nicotto = useNicotto()
const messenger = useMessenger()
nicotto.concierge.getCategory(props.categoryId)
  .then(data => {
    category.value = data
  })
nicotto.concierge.getSection(props.categoryId, props.sectionId)
  .then(data => {
    section.value = data
  })
nicotto.concierge.getQuestion(props.categoryId, props.sectionId, props.questionId)
  .then(data => {
    question.value = data
  })

const onDeleteConfirmed = async() => {
  try {
    await nicotto.concierge.deleteQuestion(question.value)
    messenger.set('concierge.questions.deleteSucceeded')
    router.push({ path: `/concierge/categories/${props.categoryId}/sections/${props.sectionId}/questions`})
  } catch (err) {
    console.log(err)
    messenger.set('concierge.questions.deleteFailed')
  }
}

const save = async() => {
  try {
    await nicotto.concierge.updateQuestion(question.value)
    messenger.set('concierge.questions.updateSucceeded')
    router.push({ path: `/concierge/categories/${props.categoryId}/sections/${props.sectionId}/questions`})
  } catch (err) {
    console.log(err)
    messenger.set('concierge.questions.updateFailed')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (category.value)
      ? (_openBlock(), _createBlock(ConciergeHeaderQuestion, {
          key: 0,
          category: category.value,
          section: section.value
        }, null, 8, ["category", "section"]))
      : _createCommentVNode("", true),
    _createVNode(QuestionForm, {
      modelValue: question.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((question).value = $event)),
      onSubmit: save,
      "category-id": __props.categoryId,
      "section-id": __props.sectionId
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: `/concierge/categories/${props.categoryId}/sections/${props.sectionId}/questions`,
            class: "btn btn-secondary mx-2",
            role: "button"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(ButtonDelete, {
            "dialog-title": "質問の削除確認",
            class: "mx-2",
            onDeleteConfirmed: onDeleteConfirmed
          }),
          _hoisted_5
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "category-id", "section-id"])
  ]))
}
}

})